// import CryptoJS from "crypto-js";

// const SECRET_KEY = "your-32-char-secret"; // store in .env

// export const encryptData = (data) => {
//   const ciphertext = CryptoJS.AES.encrypt(
//     JSON.stringify(data),
//     SECRET_KEY
//   ).toString();
//   return ciphertext;
// };

// export const decryptData = (ciphertext) => {
//   const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET_KEY);
//   const decrypted = bytes.toString(CryptoJS.enc.Utf8);
//   return JSON.parse(decrypted);
// };

// encryption.js
import CryptoJS from "crypto-js";

// Store in .env file
const SECRET_KEY = "dc0da04af8fee58593442bf834b30739";

const iterationCount = 1000;
const keySize = 128 / 32; // 128-bit = 4 words

// 🔒 ENCRYPT FUNCTION
export const encryptData = (data) => {
  const salt = CryptoJS.lib.WordArray.random(128 / 8);
  const iv = CryptoJS.lib.WordArray.random(128 / 8);

  const key = CryptoJS.PBKDF2(SECRET_KEY, salt, {
    keySize: keySize,
    iterations: iterationCount,
  });

  const encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), key, { iv });

  return JSON.stringify({
    ciphertext: encrypted.toString(),
    salt: salt.toString(),
    iv: iv.toString(),
  });
};

// 🔓 DECRYPT FUNCTION
export const decryptData = (encryptedJson) => {
  try {
    const obj = JSON.parse(encryptedJson);
    const salt = CryptoJS.enc.Hex.parse(obj.salt);
    const iv = CryptoJS.enc.Hex.parse(obj.iv);

    const key = CryptoJS.PBKDF2(SECRET_KEY, salt, {
      keySize: keySize,
      iterations: iterationCount,
    });

    const decrypted = CryptoJS.AES.decrypt(obj.ciphertext, key, { iv });

    const result = decrypted.toString(CryptoJS.enc.Utf8);
    return JSON.parse(result);
  } catch (err) {
    console.error("Decryption error:", err);
    return null;
  }
};
